import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import SerpChecker from './SerpChecker';
import ShareModal from './ShareModal';

const Hero = () => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  return (
    <section className="home-hero">
      <div className="container-max px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="home-title">Local Google SERP Checker</h1>
          <p className="mt-3 text-base sm:text-lg leading-7 text-slate-500 max-w-2xl mx-auto">
            Fresh local Google results. No VPN or signup.
          </p>
        </div>

        {/* Controls sit straight on the grey band, like the reference — no card. */}
        <section
          id="serp-checker"
          aria-label="Check a Google SERP"
          className="max-w-2xl mx-auto mt-8 sm:mt-10 scroll-mt-20"
        >
          <SerpChecker onShare={() => setIsShareModalOpen(true)} />
        </section>

        <p className="mt-6 text-center text-sm text-slate-500">
          Location is passed through Google's own{' '}
          <a href="/google-location-changer/" className="text-brand-600 hover:text-brand-700 underline underline-offset-2">
            gl and uule parameters
          </a>.
        </p>

        <div className="mt-1 text-center">
          <button
            onClick={() => setIsShareModalOpen(true)}
            className="inline-flex items-center gap-1.5 min-h-[44px] px-3 text-sm font-medium text-slate-500 hover:text-brand-600 transition-colors"
          >
            <Share2 aria-hidden="true" className="h-4 w-4" />
            Share this tool
          </button>
        </div>
      </div>

      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
      />
    </section>
  );
};

export default Hero;
